// SplitView.js
// Simple split view for VS Code-like IDE
import React, { useState } from 'react';

const SplitView = ({ left, right }) => {
  const [divider, setDivider] = useState(0.5); // 0.0 - 1.0
  const [dragging, setDragging] = useState(false);

  const handleMouseDown = (e) => {
    setDragging(true);
    e.preventDefault();
  };
  const handleMouseMove = (e) => {
    if (!dragging) return;
    const x = e.clientX;
    const width = window.innerWidth;
    setDivider(Math.max(0.1, Math.min(0.9, x / width)));
  };
  const handleMouseUp = () => setDragging(false);

  React.useEffect(() => {
    if (dragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [dragging]);

  return (
    <div style={{ display: 'flex', height: '100%', width: '100%' }}>
      <div style={{ flex: divider, minWidth: 0, height: '100%' }}>{left}</div>
      <div
        style={{ width: 8, cursor: 'col-resize', background: '#232323', zIndex: 10 }}
        onMouseDown={handleMouseDown}
      />
      <div style={{ flex: 1 - divider, minWidth: 0, height: '100%' }}>{right}</div>
    </div>
  );
};

export default SplitView;
